import { Kit } from '@repo/types';

export default function checkIfKitIsUpdating(kit?: Kit) {
  if (!kit) return false;
  const sciVersion = kit.sci_version;

  const resultsViewable =
    !!kit?.date_survey_completed && !!kit?.date_results_ready;

  if (sciVersion === null && resultsViewable) return true;

  return false;
}
